unit DonationDataEdit;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Data.DB,
  WEBLib.DB,
  WEBLib.DBCtrls,
  WebForm.Core, WEBLib.ExtCtrls,
  XData.Web.Dataset, XData.Web.JsonDataset;

type
  TDonationValidation = class
    AmountValid: Boolean;
    TransactionDateValid: Boolean;
    PaymentMethodValid: Boolean;
    DonationKindValid: Boolean;
    function PassesValidation: Boolean;
    procedure ValidateAmount(aAmount: string);
    procedure ValidatePaymentMethod(aComboItemIndex: Integer);
    procedure ValidateDonationDate(aDonationDate: TDate; out aErrorText: string);
    procedure ValidateDonationKind(aComboItemIndex: Integer);
    constructor Create;
  end;

  TDonationDataEditForm = class(TCoreWebForm)
    AmountDonation: TDBEdit;
    DonorPostCode: TDBEdit;
    SaveButton: TButton;
    CancelButton: TButton;
    ClaimStatus: TDBEdit;
    EditDataSource: TDataSource;
    DonationDateEdit: TDBDateTimePicker;
    ErrorMessageDonationDate: TLabel;
    SponsoredEditDB: TDBCheckBox;
    BankingDateEdit: TDBDateTimePicker;
    OtherDonationKindEdit: TDBEdit;
    PaymentMethodNoteEdit: TDBEdit;
    BankingReferenceEdit: TDBEdit;
    DonationKindCombo: TDBLookupComboBox;
    PaymentMethodCombo: TDBLookupComboBox;
    AnalysisCode1DefaultCombo: TDBLookupComboBox;
    AnalysisCode2DefaultCombo: TDBLookupComboBox;
    CommentMemo: TDBMemo;
    procedure AmountDonationChange(Sender: TObject);
    procedure AmountDonationKeyPress(Sender: TObject; var Key: Char);
    procedure CancelButtonClick(Sender: TObject);
    procedure CloseButtonClick(Sender: TObject);
    procedure DonationDateEditChange(Sender: TObject);
    procedure EditDataSourceDataChange(Sender: TObject; Field: TField);
    procedure SaveButtonClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure DonationKindComboChange(Sender: TObject);
    procedure OtherDonationKindEditExit(Sender: TObject);
    procedure PaymentMethodNoteEditExit(Sender: TObject);
    procedure PaymentMethodComboChange(Sender: TObject);
  private
    { Private declarations }
    FValidation: TDonationValidation;
    FEditDataApplyUpdates: boolean;
    procedure SetDataSet(Value: TDataSet);
    procedure CheckValidations;
    procedure DetermineOtherDonationKindVisibility;
    procedure DeterminePaymentMethodNoteVisibility;
    procedure DetermineConditionalUIVisibility;
    public
    { Public declarations }
    constructor Create(aOwner: TComponent); override;
    destructor Destroy; override;
    procedure CheckEdit;
    property DataSet: TDataSet write SetDataSet;
    property EditDataApplyUpdates: boolean read fEditDataApplyUpdates;
  protected procedure LoadDFMValues; override; end;

var
  DonationDataEditForm: TDonationDataEditForm;

implementation

{$R *.dfm}

uses
  DonationList, SMX.Web.Document.Utils, GA.Web.Utils;

procedure TDonationDataEditForm.AmountDonationChange(Sender: TObject);
begin
  FValidation.ValidateAmount(AmountDonation.Text);
  CheckValidations;
end;

procedure TDonationDataEditForm.AmountDonationKeyPress(Sender: TObject; var
    Key: Char);
begin
  if (Pos('.', AmountDonation.Text) > 0) and (Key = '.') then
  begin
    Key := #0;
    exit;
  end;

  if (not (Key in ['0'..'9','.','-']) or (Length(TEdit(Sender).Text) > 7)) then
  begin
    TDocUtils.setControlValidity('AmountDonation', vsInvalid);
    Key := #0;
  end
  else
  begin
    TDocUtils.setControlValidity('AmountDonation', vsValid);
  end;
end;

procedure TDonationDataEditForm.CancelButtonClick(Sender: TObject);
begin
  inherited;
  if EditDataSource.Dataset.Modified then
  begin
    EditDataSource.DataSet.Cancel;
    SaveButton.Enabled := False;
  end;
  ModalResult := mrOk;
end;

procedure TDonationDataEditForm.CloseButtonClick(Sender: TObject);
begin
  inherited;
  ModalResult := mrOk;
end;

constructor TDonationDataEditForm.Create(aOwner: TComponent);
begin
  inherited;
  FValidation := TDonationValidation.Create;
end;

procedure TDonationDataEditForm.EditDataSourceDataChange(Sender: TObject; Field: TField);
begin
  if (Field <> nil) or (EditDataSource.DataSet.Modified) then
    CancelButton.Caption := 'Cancel';
end;

procedure TDonationDataEditForm.OtherDonationKindEditExit(Sender: TObject);
begin
  if OtherDonationKindEdit.Enabled = False then
    EditDataSource.DataSet.FieldByName('OtherDonationKind').AsString := '';
end;

procedure TDonationDataEditForm.PaymentMethodComboChange(Sender: TObject);
begin
  DeterminePaymentMethodNoteVisibility;
  FValidation.ValidatePaymentMethod(PaymentMethodCombo.ItemIndex);
  if PaymentMethodCombo.Value <> TDOnationUIUtils.OTHER then
    EditDataSource.DataSet.FieldByName('PaymentMethodNote').AsString := '';
  CheckValidations;
end;

procedure TDonationDataEditForm.PaymentMethodNoteEditExit(Sender: TObject);
begin
  if PaymentMethodNoteEdit.Enabled = False then
    EditDataSource.DataSet.FieldByName('PaymentMethodNote').AsString := '';
end;

procedure TDonationDataEditForm.SaveButtonClick(Sender: TObject);
begin
  inherited;
  EditDataSource.DataSet.FieldByName('ClaimStatus').AsString := 'Unclaimed';
  EditDataSource.DataSet.Post;
  fEditDataApplyUpdates := true;
  SaveButton.Enabled := False;
  ModalResult := mrOk;
end;

procedure TDonationDataEditForm.SetDataSet(Value: TDataSet);
begin
  EditDataSource.DataSet := Value;
  DetermineConditionalUIVisibility;
  CheckEdit;
end;

procedure TDonationDataEditForm.CheckValidations;
begin
  SaveButton.Enabled := FValidation.PassesValidation;
end;

destructor TDonationDataEditForm.Destroy;
begin
  FValidation.Free;
  inherited;
end;

procedure TDonationDataEditForm.DetermineConditionalUIVisibility;
begin
  DetermineOtherDonationKindVisibility;
  DeterminePaymentMethodNoteVisibility;
end;

procedure TDonationDataEditForm.DetermineOtherDonationKindVisibility;
begin
  OtherDonationKindEdit.Visible := DonationKindCombo.Value = TDonationUIUtils.OTHER;
  if OtherDonationKindEdit.Visible then
    TDocUtils.showElement('OtherDonationKindEditLabel')
  else
    TDocUtils.hideElement('OtherDonationKindEditLabel');
end;

procedure TDonationDataEditForm.DeterminePaymentMethodNoteVisibility;
begin
  PaymentMethodNoteEdit.Visible := PaymentMethodCombo.Value = TDonationUIUtils.OTHER;
  if PaymentMethodNoteEdit.Visible then
    TDocUtils.showElement('PaymentMethodNoteEditLabel')
  else
    TDocUtils.hideElement('PaymentMethodNoteEditLabel');
end;

procedure TDonationDataEditForm.DonationDateEditChange(Sender: TObject);
var
  errorText: string;
begin
  FValidation.ValidateDonationDate(DonationDateEdit.Date, {o}errorText);
  ErrorMessageDonationDate.Caption := errorText;
  CheckValidations;
end;

procedure TDonationDataEditForm.DonationKindComboChange(Sender: TObject);
begin
  DetermineOtherDonationKindVisibility;
  FValidation.ValidateDonationKind(DonationKindCombo.ItemIndex);
  if DonationKindCombo.Value <> TDOnationUIUtils.OTHER then
    EditDataSource.DataSet.FieldByName('OtherDonationKind').AsString := '';
  CheckValidations;
end;

procedure TDonationDataEditForm.WebFormShow(Sender: TObject);
begin
  inherited;
  CancelButton.Caption := 'Close';
  TDonationUIUtils.AddPaymentMethodLookupsToCombo(PaymentMethodCombo.LookupValues);
  TDonationUIUtils.AddDonationKindLookupsToCombo(DonationKindCombo.LookupValues);
  TDonationUIUtils.AddAnalysisCodeLookupsToCombos(AnalysisCode1DefaultCombo.LookupValues, AnalysisCode2DefaultCombo.LookupValues);
end;

procedure TDonationDataEditForm.CheckEdit;
var
  errorText: string;
begin
  FValidation.ValidateAmount(AmountDonation.Text);
  FValidation.ValidateDonationDate(DonationDateEdit.Date, {o}errorText);
  ErrorMessageDonationDate.Caption := errorText;
  FValidation.ValidatePaymentMethod(PaymentMethodCombo.ItemIndex);
  FValidation.ValidateDonationKind(DonationKindCombo.ItemIndex);
  CheckValidations;
end;

//procedure TDonationDataEditForm.SetTransactionDateValid(AValid: boolean);
//begin
//  fTransactionDateValid := AValid;
//  TDocUtils.setControlValidity('DonationDateEdit', vsValid);
//  CheckValidations;
//end;

{ TDonationValidation }

constructor TDonationValidation.Create;
begin
  AmountValid := False;
  TransactionDateValid := False;
  DonationKindValid := False;
  PaymentMethodValid := False;
end;

function TDonationValidation.PassesValidation: Boolean;
begin
  Result := AmountValid and DonationKindValid and TransactionDateValid and PaymentMethodValid;
end;

procedure TDonationValidation.ValidateAmount(aAmount: string);
var
  AdjValue: currency;
begin
  if aAmount <> '' then
  begin
    AdjValue := strtofloat(aAmount);

    if AdjValue > 0 then
    begin
      TDocUtils.setControlValidity('AmountDonation', vsValid);
      AmountValid := True;
    end
    else if AdjValue < 0 then
    begin
      TDocUtils.setControlValidity('AmountDonation', vsValid);
      AmountValid := True;
    end;
  end
  else
  begin
    TDocUtils.setControlValidity('AmountDonation', vsInvalid);
    AmountValid := False;
  end;
end;

procedure TDonationValidation.ValidateDonationDate(aDonationDate: TDate; out aErrorText: string);
var
  EarliestDate: TDateTime;
begin
  TransactionDateValid := True;

  if aDonationDate = 0 then
  begin
    aErrorText := 'Donation Date cannot be blank';
    TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
    TransactionDateValid := False;
  end
  else if aDonationDate > Date then
  begin
    aErrorText := 'Donation Date in the future';
    TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
    TransactionDateValid := False;
  end
  else
  begin
    EarliestDate := TGAWebUtils.EarliestClaimableDate(Now);

    if EarliestDate > aDonationDate then
    begin
      aErrorText := 'Donation Date cannot be before ' + FormatDateTime('DD/MM/YYYY', EarliestDate);
      TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
      TransactionDateValid := False;
    end;
  end;

  if TransactionDateValid then
    TDocUtils.setControlValidity('DonationDateEdit', vsValid);
end;

procedure TDonationValidation.ValidateDonationKind(aComboItemIndex: Integer);
begin
  DonationKindValid := aComboItemIndex <> -1;
  if DonationKindValid then
    TDocUtils.setControlValidity('DonationKindCombo', vsValid)
  else
    TDocUtils.setControlValidity('DonationKindCombo', vsInvalid);
end;

procedure TDonationValidation.ValidatePaymentMethod(aComboItemIndex: Integer);
begin
  PaymentMethodValid := aComboItemIndex <> -1;
  if PaymentMethodValid then
    TDocUtils.setControlValidity('PaymentMethodCombo', vsValid)
  else
    TDocUtils.setControlValidity('PaymentMethodCombo', vsInvalid);
end;

procedure TDonationDataEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ErrorMessageDonationDate := TLabel.Create('ErrorMessageDonationDate');
  AmountDonation := TDBEdit.Create('AmountDonation');
  DonorPostCode := TDBEdit.Create('DonorPostCode');
  SaveButton := TButton.Create('SaveButton');
  CancelButton := TButton.Create('CancelButton');
  ClaimStatus := TDBEdit.Create('ClaimStatus');
  DonationDateEdit := TDBDateTimePicker.Create('DonationDateEdit');
  SponsoredEditDB := TDBCheckBox.Create('SponsoredEditDB');
  BankingDateEdit := TDBDateTimePicker.Create('BankingDate');
  OtherDonationKindEdit := TDBEdit.Create('OtherDonationKindEdit');
  PaymentMethodNoteEdit := TDBEdit.Create('PaymentMethodNoteEdit');
  BankingReferenceEdit := TDBEdit.Create('BankingReferenceEdit');
  DonationKindCombo := TDBLookupComboBox.Create('DonationKindCombo');
  PaymentMethodCombo := TDBLookupComboBox.Create('PaymentMethodCombo');
  AnalysisCode1DefaultCombo := TDBLookupComboBox.Create('AnalysisCode1DefaultCombo');
  AnalysisCode2DefaultCombo := TDBLookupComboBox.Create('AnalysisCode2DefaultCombo');
  CommentMemo := TDBMemo.Create('CommentMemo');
  EditDataSource := TDataSource.Create(Self);

  ErrorMessageDonationDate.BeforeLoadDFMValues;
  AmountDonation.BeforeLoadDFMValues;
  DonorPostCode.BeforeLoadDFMValues;
  SaveButton.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  ClaimStatus.BeforeLoadDFMValues;
  DonationDateEdit.BeforeLoadDFMValues;
  SponsoredEditDB.BeforeLoadDFMValues;
  BankingDateEdit.BeforeLoadDFMValues;
  OtherDonationKindEdit.BeforeLoadDFMValues;
  PaymentMethodNoteEdit.BeforeLoadDFMValues;
  BankingReferenceEdit.BeforeLoadDFMValues;
  DonationKindCombo.BeforeLoadDFMValues;
  PaymentMethodCombo.BeforeLoadDFMValues;
  AnalysisCode1DefaultCombo.BeforeLoadDFMValues;
  AnalysisCode2DefaultCombo.BeforeLoadDFMValues;
  CommentMemo.BeforeLoadDFMValues;
  EditDataSource.BeforeLoadDFMValues;
  try
    Width := 567;
    Height := 682;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ErrorMessageDonationDate.SetParentComponent(Self);
    ErrorMessageDonationDate.Name := 'ErrorMessageDonationDate';
    ErrorMessageDonationDate.Left := 344;
    ErrorMessageDonationDate.Top := 8;
    ErrorMessageDonationDate.Width := 144;
    ErrorMessageDonationDate.Height := 15;
    ErrorMessageDonationDate.Caption := 'ErrorMessageDonationDate';
    ErrorMessageDonationDate.HeightPercent := 100.000000000000000000;
    ErrorMessageDonationDate.WidthPercent := 100.000000000000000000;
    AmountDonation.SetParentComponent(Self);
    AmountDonation.Name := 'AmountDonation';
    AmountDonation.Left := 40;
    AmountDonation.Top := 8;
    AmountDonation.Width := 121;
    AmountDonation.Height := 22;
    AmountDonation.AutoCompletion := acNone;
    AmountDonation.AutoSelect := False;
    AmountDonation.ChildOrder := 1;
    AmountDonation.ElementClassName := 'form-control';
    AmountDonation.ElementFont := efCSS;
    AmountDonation.ElementPosition := epIgnore;
    AmountDonation.HeightStyle := ssAuto;
    AmountDonation.HeightPercent := 100.000000000000000000;
    AmountDonation.Text := 'AmountDonation';
    AmountDonation.WidthStyle := ssAuto;
    AmountDonation.WidthPercent := 100.000000000000000000;
    SetEvent(AmountDonation, Self, 'OnChange', 'AmountDonationChange');
    SetEvent(AmountDonation, Self, 'OnExit', 'AmountDonationChange');
    SetEvent(AmountDonation, Self, 'OnKeyPress', 'AmountDonationKeyPress');
    AmountDonation.DataField := 'Amount';
    AmountDonation.DataSource := EditDataSource;
    DonorPostCode.SetParentComponent(Self);
    DonorPostCode.Name := 'DonorPostCode';
    DonorPostCode.Left := 40;
    DonorPostCode.Top := 64;
    DonorPostCode.Width := 121;
    DonorPostCode.Height := 22;
    DonorPostCode.AutoCompletion := acNone;
    DonorPostCode.AutoSelect := False;
    DonorPostCode.ChildOrder := 3;
    DonorPostCode.ElementClassName := 'form-control';
    DonorPostCode.ElementFont := efCSS;
    DonorPostCode.ElementPosition := epIgnore;
    DonorPostCode.HeightStyle := ssAuto;
    DonorPostCode.HeightPercent := 100.000000000000000000;
    DonorPostCode.TabOrder := 2;
    DonorPostCode.Text := 'DonorPostCode';
    DonorPostCode.Visible := False;
    DonorPostCode.WidthStyle := ssAuto;
    DonorPostCode.WidthPercent := 100.000000000000000000;
    SaveButton.SetParentComponent(Self);
    SaveButton.Name := 'SaveButton';
    SaveButton.Left := 40;
    SaveButton.Top := 622;
    SaveButton.Width := 96;
    SaveButton.Height := 25;
    SaveButton.Caption := 'Save';
    SaveButton.ChildOrder := 4;
    SaveButton.ElementClassName := 'btn btn-light';
    SaveButton.ElementFont := efCSS;
    SaveButton.ElementPosition := epIgnore;
    SaveButton.Enabled := False;
    SaveButton.HeightStyle := ssAuto;
    SaveButton.HeightPercent := 100.000000000000000000;
    SaveButton.WidthStyle := ssAuto;
    SaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveButton, Self, 'OnClick', 'SaveButtonClick');
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 152;
    CancelButton.Top := 622;
    CancelButton.Width := 96;
    CancelButton.Height := 25;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 5;
    CancelButton.ElementClassName := 'btn btn-light';
    CancelButton.ElementFont := efCSS;
    CancelButton.ElementPosition := epIgnore;
    CancelButton.HeightStyle := ssAuto;
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.WidthStyle := ssAuto;
    CancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelButton, Self, 'OnClick', 'CancelButtonClick');
    ClaimStatus.SetParentComponent(Self);
    ClaimStatus.Name := 'ClaimStatus';
    ClaimStatus.Left := 40;
    ClaimStatus.Top := 92;
    ClaimStatus.Width := 300;
    ClaimStatus.Height := 22;
    ClaimStatus.AutoCompletion := acNone;
    ClaimStatus.AutoSelect := False;
    ClaimStatus.ChildOrder := 4;
    ClaimStatus.ElementClassName := 'form-control';
    ClaimStatus.ElementFont := efCSS;
    ClaimStatus.ElementPosition := epIgnore;
    ClaimStatus.HeightStyle := ssAuto;
    ClaimStatus.HeightPercent := 100.000000000000000000;
    ClaimStatus.TabOrder := 3;
    ClaimStatus.Text := 'ClaimStatus';
    ClaimStatus.Visible := False;
    ClaimStatus.WidthStyle := ssAuto;
    ClaimStatus.WidthPercent := 100.000000000000000000;
    ClaimStatus.DataField := 'ClaimStatus';
    ClaimStatus.DataSource := EditDataSource;
    DonationDateEdit.SetParentComponent(Self);
    DonationDateEdit.Name := 'DonationDateEdit';
    DonationDateEdit.Left := 40;
    DonationDateEdit.Top := 36;
    DonationDateEdit.Width := 121;
    DonationDateEdit.Height := 22;
    DonationDateEdit.ElementClassName := 'form-control';
    DonationDateEdit.HeightStyle := ssAuto;
    DonationDateEdit.WidthStyle := ssAuto;
    DonationDateEdit.BorderStyle := bsSingle;
    DonationDateEdit.ChildOrder := 8;
    DonationDateEdit.Color := clWhite;
    DonationDateEdit.Date := 45191.330952881940000000;
    DonationDateEdit.ElementFont := efCSS;
    DonationDateEdit.ElementPosition := epIgnore;
    DonationDateEdit.Role := '';
    DonationDateEdit.Text := 'DonationDateEdit';
    SetEvent(DonationDateEdit, Self, 'OnChange', 'DonationDateEditChange');
    DonationDateEdit.DataField := 'TransactionDate';
    DonationDateEdit.DataSource := EditDataSource;
    SponsoredEditDB.SetParentComponent(Self);
    SponsoredEditDB.Name := 'SponsoredEditDB';
    SponsoredEditDB.Left := 40;
    SponsoredEditDB.Top := 364;
    SponsoredEditDB.Width := 113;
    SponsoredEditDB.Height := 22;
    SponsoredEditDB.Caption := 'Sponsored';
    SponsoredEditDB.ChildOrder := 15;
    SponsoredEditDB.ElementClassName := 'custom-control custom-checkbox';
    SponsoredEditDB.ElementButtonClassName := 'custom-control-input';
    SponsoredEditDB.ElementLabelClassName := 'custom-control-label';
    SponsoredEditDB.ElementFont := efCSS;
    SponsoredEditDB.ElementPosition := epIgnore;
    SponsoredEditDB.HeightStyle := ssAuto;
    SponsoredEditDB.HeightPercent := 100.000000000000000000;
    SponsoredEditDB.TabOrder := 14;
    SponsoredEditDB.WidthStyle := ssAuto;
    SponsoredEditDB.WidthPercent := 100.000000000000000000;
    SponsoredEditDB.DataField := 'Sponsored';
    SponsoredEditDB.DataSource := EditDataSource;
    BankingDateEdit.SetParentComponent(Self);
    BankingDateEdit.Name := 'BankingDateEdit';
    BankingDateEdit.Left := 40;
    BankingDateEdit.Top := 336;
    BankingDateEdit.Width := 170;
    BankingDateEdit.Height := 22;
    BankingDateEdit.ElementClassName := 'form-control';
    BankingDateEdit.BorderStyle := bsSingle;
    BankingDateEdit.ChildOrder := 17;
    BankingDateEdit.Color := clWhite;
    BankingDateEdit.Date := 45978.612005416670000000;
    BankingDateEdit.Role := '';
    BankingDateEdit.Text := 'dd/mm/yyyy';
    BankingDateEdit.DataField := 'BankingDate';
    BankingDateEdit.DataSource := EditDataSource;
    OtherDonationKindEdit.SetParentComponent(Self);
    OtherDonationKindEdit.Name := 'OtherDonationKindEdit';
    OtherDonationKindEdit.Left := 40;
    OtherDonationKindEdit.Top := 160;
    OtherDonationKindEdit.Width := 504;
    OtherDonationKindEdit.Height := 22;
    OtherDonationKindEdit.AutoSelect := False;
    OtherDonationKindEdit.ChildOrder := 17;
    OtherDonationKindEdit.ElementClassName := 'form-control';
    OtherDonationKindEdit.HeightPercent := 100.000000000000000000;
    OtherDonationKindEdit.WidthPercent := 100.000000000000000000;
    SetEvent(OtherDonationKindEdit, Self, 'OnExit', 'OtherDonationKindEditExit');
    OtherDonationKindEdit.DataField := 'OtherDonationKind';
    OtherDonationKindEdit.DataSource := EditDataSource;
    PaymentMethodNoteEdit.SetParentComponent(Self);
    PaymentMethodNoteEdit.Name := 'PaymentMethodNoteEdit';
    PaymentMethodNoteEdit.Left := 40;
    PaymentMethodNoteEdit.Top := 225;
    PaymentMethodNoteEdit.Width := 504;
    PaymentMethodNoteEdit.Height := 22;
    PaymentMethodNoteEdit.AutoSelect := False;
    PaymentMethodNoteEdit.ChildOrder := 17;
    PaymentMethodNoteEdit.ElementClassName := 'form-control';
    PaymentMethodNoteEdit.HeightPercent := 100.000000000000000000;
    PaymentMethodNoteEdit.WidthPercent := 100.000000000000000000;
    SetEvent(PaymentMethodNoteEdit, Self, 'OnExit', 'PaymentMethodNoteEditExit');
    PaymentMethodNoteEdit.DataField := 'PaymentMethodNote';
    PaymentMethodNoteEdit.DataSource := EditDataSource;
    BankingReferenceEdit.SetParentComponent(Self);
    BankingReferenceEdit.Name := 'BankingReferenceEdit';
    BankingReferenceEdit.Left := 216;
    BankingReferenceEdit.Top := 336;
    BankingReferenceEdit.Width := 328;
    BankingReferenceEdit.Height := 22;
    BankingReferenceEdit.AutoSelect := False;
    BankingReferenceEdit.ChildOrder := 17;
    BankingReferenceEdit.ElementClassName := 'form-control';
    BankingReferenceEdit.HeightPercent := 100.000000000000000000;
    BankingReferenceEdit.WidthPercent := 100.000000000000000000;
    BankingReferenceEdit.DataField := 'BankingReference';
    BankingReferenceEdit.DataSource := EditDataSource;
    DonationKindCombo.SetParentComponent(Self);
    DonationKindCombo.Name := 'DonationKindCombo';
    DonationKindCombo.Left := 40;
    DonationKindCombo.Top := 120;
    DonationKindCombo.Width := 145;
    DonationKindCombo.Height := 22;
    DonationKindCombo.HeightPercent := 100.000000000000000000;
    DonationKindCombo.WidthPercent := 100.000000000000000000;
    SetEvent(DonationKindCombo, Self, 'OnChange', 'DonationKindComboChange');
    DonationKindCombo.DataField := 'DonationKind';
    DonationKindCombo.DataSource := EditDataSource;
    PaymentMethodCombo.SetParentComponent(Self);
    PaymentMethodCombo.Name := 'PaymentMethodCombo';
    PaymentMethodCombo.Left := 40;
    PaymentMethodCombo.Top := 197;
    PaymentMethodCombo.Width := 145;
    PaymentMethodCombo.Height := 22;
    PaymentMethodCombo.HeightPercent := 100.000000000000000000;
    PaymentMethodCombo.WidthPercent := 100.000000000000000000;
    SetEvent(PaymentMethodCombo, Self, 'OnChange', 'PaymentMethodComboChange');
    PaymentMethodCombo.DataField := 'PaymentMethod';
    PaymentMethodCombo.DataSource := EditDataSource;
    AnalysisCode1DefaultCombo.SetParentComponent(Self);
    AnalysisCode1DefaultCombo.Name := 'AnalysisCode1DefaultCombo';
    AnalysisCode1DefaultCombo.Left := 40;
    AnalysisCode1DefaultCombo.Top := 261;
    AnalysisCode1DefaultCombo.Width := 361;
    AnalysisCode1DefaultCombo.Height := 22;
    AnalysisCode1DefaultCombo.HeightPercent := 100.000000000000000000;
    AnalysisCode1DefaultCombo.WidthPercent := 100.000000000000000000;
    AnalysisCode1DefaultCombo.DataField := 'AnalysisCode1';
    AnalysisCode1DefaultCombo.DataSource := EditDataSource;
    AnalysisCode2DefaultCombo.SetParentComponent(Self);
    AnalysisCode2DefaultCombo.Name := 'AnalysisCode2DefaultCombo';
    AnalysisCode2DefaultCombo.Left := 40;
    AnalysisCode2DefaultCombo.Top := 301;
    AnalysisCode2DefaultCombo.Width := 361;
    AnalysisCode2DefaultCombo.Height := 22;
    AnalysisCode2DefaultCombo.HeightPercent := 100.000000000000000000;
    AnalysisCode2DefaultCombo.WidthPercent := 100.000000000000000000;
    AnalysisCode2DefaultCombo.DataField := 'AnalysisCode2';
    AnalysisCode2DefaultCombo.DataSource := EditDataSource;
    CommentMemo.SetParentComponent(Self);
    CommentMemo.Name := 'CommentMemo';
    CommentMemo.Left := 40;
    CommentMemo.Top := 406;
    CommentMemo.Width := 419;
    CommentMemo.Height := 196;
    CommentMemo.ElementClassName := 'form-control';
    CommentMemo.HeightPercent := 100.000000000000000000;
    CommentMemo.Lines.BeginUpdate;
    try
      CommentMemo.Lines.Clear;
      CommentMemo.Lines.Add('CommentMemo');
    finally
      CommentMemo.Lines.EndUpdate;
    end;
    CommentMemo.SelLength := 0;
    CommentMemo.SelStart := 0;
    CommentMemo.WidthPercent := 100.000000000000000000;
    CommentMemo.DataField := 'Comment';
    CommentMemo.DataSource := EditDataSource;
    EditDataSource.SetParentComponent(Self);
    EditDataSource.Name := 'EditDataSource';
    SetEvent(EditDataSource, Self, 'OnDataChange', 'EditDataSourceDataChange');
    EditDataSource.Left := 216;
    EditDataSource.Top := 24;
  finally
    ErrorMessageDonationDate.AfterLoadDFMValues;
    AmountDonation.AfterLoadDFMValues;
    DonorPostCode.AfterLoadDFMValues;
    SaveButton.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    ClaimStatus.AfterLoadDFMValues;
    DonationDateEdit.AfterLoadDFMValues;
    SponsoredEditDB.AfterLoadDFMValues;
    BankingDateEdit.AfterLoadDFMValues;
    OtherDonationKindEdit.AfterLoadDFMValues;
    PaymentMethodNoteEdit.AfterLoadDFMValues;
    BankingReferenceEdit.AfterLoadDFMValues;
    DonationKindCombo.AfterLoadDFMValues;
    PaymentMethodCombo.AfterLoadDFMValues;
    AnalysisCode1DefaultCombo.AfterLoadDFMValues;
    AnalysisCode2DefaultCombo.AfterLoadDFMValues;
    CommentMemo.AfterLoadDFMValues;
    EditDataSource.AfterLoadDFMValues;
  end;
end;

end.
